const initialState = {
  pathname: undefined,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'LOCATION_CHANGE': {
      const pathname = action.payload.location.pathname;
      const search = action.payload.location.search;
      return Object.assign({}, state, { pathname, search });
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./home/reducers/reducer-router.js